<template>
  <div class="scs-location-details-simple">
    <div v-if="location">
      <p v-for="(field, index) in locationFields" :key="index">
        {{ field }}
      </p>
    </div>

    <div v-if="!location">
      <p class="skeleton"></p>
      <p class="skeleton"></p>
      <p class="skeleton"></p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    locationFields() {
      if (this.location) {
        switch (this.location.api_version) {
          case "9-28-2022":
            return [
              this.location.Name,
              `${this.location.AddressNumber} ${this.location.Street}`,
              `${this.location.Municipality}, ${this.location.Region}`,
            ];
          default:
            if (this.location.address === undefined) {
              return [];
            } else {
              return [
                this.location.name,
                ...Object.values(this.location.address),
              ];
            }
        }
      } else {
        return [];
      }
    },
  },
  props: ["location"],
};
</script>
<style scoped>
.scs-location-details-simple {
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.skeleton {
  width: 50px;
  height: 0.7em;
  background-color: var(--secondaryColor);
  margin: 5px 0px;
}

p {
  margin: 0px;
  font-weight: 500;
  font-size: 0.65em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
